// VIEW
// TODO Подумать как хранить константы, все вместе, или в папке pages отдельно.
// Page Calls, EngineeringsCalls
export const CAN_VIEW_TOOLTIP_TRANSFER_INTO_OPERATION = 'CAN_VIEW_TOOLTIP_TRANSFER_INTO_OPERATION';

// Page ApartmentStatus
export const CAN_VIEW_BTN_SEND_NOTIFICATION = 'CAN_VIEW_BTN_SEND_NOTIFICATION'; // Отправить уведомление
export const CAN_VIEW_BTN_MAKE_CALL = 'CAN_VIEW_BTN_MAKE_CALL'; // Сделать вызов

// Page TimeTable TimeTableApartments
export const CAN_ADD_SCHEDULE = 'CAN_ADD_SCHEDULE'; // Добавить расписание

// Page EngineeringSetting
export const CAN_ADD_EMPLOYEE = 'CAN_ADD_EMPLOYEE'; // Добавить сотрудника

// Page
export const CAN_VIEW_CHECKBOX_CHOOSE_ALL = 'CAN_VIEW_CHECKBOX_CHOOSE_ALL'; // Выбрать все

// Page
export const CAN_VIEW_BTN_START_SETTLING = 'CAN_VIEW_BTN_START_SETTLING'; // Начать заселение
